import React from "react";
import { Clock, MapPin, Ticket } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { mumbaiDestinations } from "../mock";
import { useReveal } from "../hooks/useReveal";

const AboutMumbai = () => {
  useReveal();
  return (
    <div>
      <PageHeader title="About Mumbai" crumb="About Mumbai" subtitle="Aamchi Mumbai — explore the city's iconic landmarks and vibrant culture." />

      <section className="section-pad bg-white">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="reveal max-w-3xl mx-auto text-center mb-14">
            <h2 className="font-display font-extrabold text-3xl md:text-4xl text-navy-900">Mumbai</h2>
            <p className="mt-2 text-brand font-semibold text-lg">Aamchi Mumbai</p>
            <p className="mt-4 text-slate-600 leading-relaxed">
              Mumbai, the bustling financial capital of India, is a city of contrasts — home to historic colonial architecture, vibrant street life, iconic seaside spots, and the heart of Bollywood. As you attend DRS 2026, explore Mumbai's dynamic spirit that seamlessly blends tradition and modernity, offering unforgettable experiences beyond the conference.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {mumbaiDestinations.map((dest) => (
              <div key={dest.title} className="reveal group bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden card-hover">
                <div className="relative h-56 overflow-hidden">
                  <img src={dest.image} alt={dest.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  <div className="absolute inset-x-0 bottom-0 h-1 bg-brand" />
                </div>
                <div className="p-6">
                  <h3 className="font-display font-bold text-xl text-navy-900">{dest.title}</h3>
                  <p className="mt-2 text-sm text-slate-500 leading-relaxed">{dest.desc}</p>
                  <div className="mt-4 flex flex-wrap gap-3">
                    <span className="inline-flex items-center gap-1.5 text-xs font-medium text-slate-600 bg-slate-100 rounded-full px-3 py-1">
                      <MapPin className="w-3.5 h-3.5 text-brand" /> {dest.distance}
                    </span>
                    <span className="inline-flex items-center gap-1.5 text-xs font-medium text-slate-600 bg-slate-100 rounded-full px-3 py-1">
                      <Clock className="w-3.5 h-3.5 text-brand" /> {dest.time}
                    </span>
                    <span className="inline-flex items-center gap-1.5 text-xs font-medium text-slate-600 bg-slate-100 rounded-full px-3 py-1">
                      <Ticket className="w-3.5 h-3.5 text-brand" /> {dest.fee}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutMumbai;
